import { Link } from "react-router-dom";

const areaLinks = [
  { name: "Manchester", path: "/management/manchester/" },
  { name: "Liverpool", path: "/management/liverpool/" },
  { name: "London", path: "/management/london/" },
  { name: "Birmingham", path: "/management/birmingham/" },
  { name: "Leeds", path: "/management/leeds/" },
  { name: "Sheffield", path: "/management/sheffield/" },
  { name: "Newcastle", path: "/management/newcastle/" },
  { name: "Chester", path: "/management/chester/" },
  { name: "Stockport", path: "/management/stockport/" },
  { name: "Stoke-on-Trent", path: "/management/stoke-on-trent/" },
  { name: "Brighton", path: "/management/brighton/" },
  { name: "Oxford", path: "/management/oxford/" },
  { name: "Bath", path: "/management/bath/" },
  { name: "Essex", path: "/management/essex/" },
  { name: "Slough", path: "/management/slough/" },
  { name: "Southampton", path: "/management/southampton/" },
];

const companyLinks = [
  { name: "Interiors & Staging", path: "/interiors" },
  { name: "About us", path: "/about" },
  { name: "FAQs", path: "/faqs" },
  { name: "Support", path: "/support" },
  { name: "Privacy policy", path: "/privacy-policy" },
  { name: "Terms & Conditions", path: "/terms-and-conditions" },
  { name: "Contact us", path: "/support" },
];

const pad = "clamp(20px, 5vw, 80px)";

export default function ManchesterFooter() {
  return (
    <footer style={{
      backgroundColor: "#112215",
      paddingTop: "clamp(40px, 5vw, 64px)",
      paddingLeft: pad,
      paddingRight: pad,
      paddingBottom: 28,
      marginTop: 0,
    }}>
      <div style={{ maxWidth: 1200, margin: "0 auto", paddingTop: 12 }}>
        {/* Main grid */}
        <div style={{ display: "grid", gridTemplateColumns: "2fr 2fr 1fr", gap: 40, marginBottom: 40 }} className="footer-grid">
          {/* Brand col */}
          <div>
            <img src="https://media.base44.com/images/public/6a316287a1be7d9945ac7d10/24682ceeb_TruestaysLogo.png" alt="Truestays" style={{ height: 22, width: "auto" }} />
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.3)", lineHeight: 1.5, marginTop: 10, marginBottom: 0 }}>Serviced accommodation & short-let rental company.</p>
          </div>

          {/* Areas */}
          <div>
            <div style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: 10, textTransform: "uppercase", letterSpacing: "0.08em", color: "rgba(255,255,255,0.25)", marginBottom: 12 }}>Areas we cover</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 16px" }}>
              {areaLinks.map((area) => (
                <Link key={area.name} to={area.path} style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.45)", display: "block", marginBottom: 7, textDecoration: "none", transition: "color 0.2s" }}
                  onMouseEnter={e => e.target.style.color = "white"}
                  onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.45)"}
                >{area.name}</Link>
              ))}
            </div>
          </div>

          {/* Company */}
          <div>
            <div style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 700, fontSize: 10, textTransform: "uppercase", letterSpacing: "0.08em", color: "rgba(255,255,255,0.25)", marginBottom: 12 }}>Company</div>
            {companyLinks.map((item) => (
              <Link key={item.name} to={item.path} style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.45)", display: "block", marginBottom: 7, textDecoration: "none", transition: "color 0.2s" }}
                onMouseEnter={e => e.target.style.color = "white"}
                onMouseLeave={e => e.target.style.color = "rgba(255,255,255,0.45)"}
              >{item.name}</Link>
            ))}
          </div>
        </div>

        {/* Bottom */}
        <div style={{ borderTop: "1px solid rgba(255,255,255,0.06)", paddingTop: 18, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
          <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.2)" }}>© 2026 All Rights Reserved.</span>
          <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.2)" }}>truestays group ltd</span>
        </div>
      </div>

      <style>{`
        @media (max-width: 900px) { .footer-grid { grid-template-columns: 1fr 1fr 1fr !important; } .footer-grid > div:first-child { grid-column: 1 / -1; } }
        @media (max-width: 600px) { .footer-grid { grid-template-columns: 1fr 1fr !important; } }
        @media (max-width: 480px) { .footer-grid { grid-template-columns: 1fr !important; } }
      `}</style>
    </footer>
  );
}